import { useEffect } from 'react';
import { useMephistoReview } from '../../shims/mephisto-review-hook';

const DEFAULT_THEME = {
  '--app-primaryColor': '#7762ce',
}

const ThemeLoader = () => {
  const { versionConfig } = useMephistoReview();

  useEffect(() => {
    const theme = versionConfig?.theme ?? {}

    for (const var_name in DEFAULT_THEME) {
      document.documentElement.style.setProperty(var_name, theme[var_name] ?? DEFAULT_THEME[var_name])
    }
  }, [versionConfig]);

  return null;
};

export { ThemeLoader, DEFAULT_THEME };
